import Grid from '@mui/material/Grid'

import type { GroupedFilterOption } from '@models/Filter'

import { SelectObject } from '../../../core/components/SelectObject'
import FilterGridItem from '../../../core/components/toolbar/FilterGridItem'
import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'

interface Props {
  onChange: (filters: ContractinstellingenSearchFilters) => void
  filters: ContractinstellingenSearchFilters
  options: {
    verantwoordelijken: GroupedFilterOption[]
  }
}

export const ContractinstellingenFilters = ({
  onChange,
  filters,
  options: { verantwoordelijken },
}: Props) => {
  const { verantwoordelijke } = filters

  const handleFilterChange = (filter: Partial<typeof filters>) => {
    const newFilter = { ...filters, ...filter }

    onChange(newFilter)
  }

  return (
    <Grid spacing={2} container sx={{ marginBottom: 4 }}>
      <FilterGridItem>
        <SelectObject
          label="Project verantwoordelijke"
          value={verantwoordelijke}
          options={verantwoordelijken}
          onChange={(value) => {
            handleFilterChange({ verantwoordelijke: value })
          }}
          variant="outlined"
        />
      </FilterGridItem>
    </Grid>
  )
}
